import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class JeeVerificationService {
  private token = "eyJhbGciOiJIUzUxMiJ9.eyJkZXZpY2VTZXNzaW9uSWQiOiJJUVg0bUlaT3VKSiUyQmZJcVRwTjNRNUhBY0U2TWkzeVcxV1JpcEVFOGFIdXpJYWJGb3RxbVRwakdSVmdGVHNEWm55cmxIYlFBdVBqUFdaZ29ld2huVkhNNDlIdktUQk9rbVk2N1VrJTJGeUFaJTJGRSUzRCIsInRva2VuUmVmcmVzaEtleSI6InBDZ3Z4djhFdzNTbWZZTkI2cWw2R0F2Y3YxamZVTlNsSnUyenN5ektRSVAwek83bUpzczJEZFB5dWlub0ZvenMiLCJjYW1wdXNJZCI6MTc5LCJwYXlyb2xsSWQiOiJIWUQxMDMxMzUiLCJ1c2VyTmFtZSI6IkNIIFNBVFlBTkFSQVlBTkEiLCJleHAiOjE3NjkyMzU0MTMsInVzZXJJZCI6IkhZRDEwMzEzNSIsImlhdCI6MTc2OTE0OTAxMywidW5pcXVlSWQiOjI4NDg2LCJwbGF0Zm9ybSI6IlNDQUlUUyIsImp0aSI6ImNiNDgyMjkxLTUzMDItNDA3OS1hNmZlLTA5YTAzNjcyNTJlOSJ9.6Y2id6rsgvJqYmqMuwL7IWihFNlXE3LFe0XAxPR1OUuuMW3fHIcvbQimEx8rSuXSH--XGIMBDALig_OPh-DDlQ";

  private pythonUrl='http://192.168.20.125:8000'

  constructor(private http: HttpClient) { }

  getSearchJeeMains(searchCriteria: any) {
    const headers = new HttpHeaders({
      'Authorization': `${this.token}`
    });
    const groupName = 'M.P.C';
    return this.http.get(environment.masterDomain + '/employee/api/jwtV2/admNoSearch?searchCriteria=' + searchCriteria + '&groupName=' + groupName, { headers });
  }

  getStudentList(admNo: any) {
    const headers = new HttpHeaders({
      'Authorization': `${this.token}`
    });
    const mainSession = 'JeeMainsSession1';
    return this.http.get(environment.masterDomain + '/employee/api/jwtV2/jeemains/admNoWiseStudentList?admNo=' + admNo + '&mainSession=' + mainSession, { headers })
  }

  studentPdfUpload(file: File) {
    const formData = new FormData();
    formData.append('file', file); // key must match backend
    const headers = new HttpHeaders({
      'Authorization': `${this.token}`
    });
    return this.http.post(this.pythonUrl + '/process/pdf', formData, { headers });
  }

}
